import type { Citation } from "@expert/shared-types";

import { useReactAnalytics } from "@asurion-core/eventualize-react";
import { Group, Text, Tooltip } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { useEffect, useMemo, useState } from "react";

import { MagnifyingGlass } from "./MagnifyingGlass";

export function CitationsHeader({ citations }: { citations: Citation[] }) {
    const { dispatcher } = useReactAnalytics();
    const { hovered, ref } = useHover();
    const [hoverTracked, setHoverTracked] = useState(false);

    const sources = useMemo(() => citations.map((citation) => citation.domain), [citations]);

    useEffect(() => {
        if (hovered && !hoverTracked) {
            void dispatcher.dispatchBusinessEvent("CitationDetailsDisplayed", {
                citations: sources,
                citationCount: sources.length,
            });
            setHoverTracked(true);
        }
    }, [hovered, dispatcher, hoverTracked, sources]);

    return (
        <Group
            bg={"#242B32"}
            gap="3xs"
            p="sm"
            styles={{ root: { borderTopLeftRadius: "1.25rem", borderTopRightRadius: "1.25rem" } }}
        >
            <MagnifyingGlass />
            <Text size="sm" fw={700}>
                Searched the web
            </Text>
            <Tooltip label={sources.join(", ")}>
                <Text size="sm" c="primary.2" ref={ref}>
                    • {sources.length} source{sources.length > 1 ? "s" : ""}
                </Text>
            </Tooltip>
        </Group>
    );
}
